import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';

export interface LogServiceFeConfig {
  endpoint?: string;
  adminEndpoint?: string;
  serviceName: string;
  defaultComponent?: string;
}

export const LOG_SERVICE_FE_CONFIG = new InjectionToken<LogServiceFeConfig>(
  'LOG_SERVICE_FE_CONFIG',
);

export function provideLogServiceFe(
  config: LogServiceFeConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: LOG_SERVICE_FE_CONFIG,
      useValue: config,
    },
  ]);
}
